import { render, staticRenderFns } from "./addVersion.vue?vue&type=template&id=5a1566b6&scoped=true&"
import script from "./addVersion.vue?vue&type=script&lang=js&"
export * from "./addVersion.vue?vue&type=script&lang=js&"
import style0 from "./addVersion.vue?vue&type=style&index=0&id=5a1566b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1566b6",
  null
  
)

export default component.exports